import React from "react";
import { ArrowUpRight, ArrowDown } from "lucide-react";
import { companyInfo, stats } from "../mock";

const Hero = () => {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden">
      <div className="icg-container">
        <div className="flex items-center gap-3 icg-fade-up">
          <span className="icg-dot" />
          <span className="icg-eyebrow">Est. {companyInfo.foundedYear} · Dallas · Detroit · Chandigarh</span>
        </div>

        <h1 className="font-display font-semibold tracking-tight mt-8 icg-fade-up delay-1"
            style={{ fontSize: "clamp(44px, 8vw, 128px)", lineHeight: 0.94 }}>
          A creative
          <br />
          & digital <span className="font-serif-it text-[color:var(--icg-accent)]">agency</span>
          <br />
          for brands that
          <br />
          refuse to blend in.
        </h1>

        <div className="mt-10 md:mt-14 grid md:grid-cols-12 gap-8 icg-fade-up delay-2">
          <div className="md:col-span-5 md:col-start-1">
            <p className="text-[color:var(--icg-muted)] text-lg leading-relaxed max-w-md">
              {companyInfo.subheadline} Since {companyInfo.foundedYear}, {companyInfo.name} has helped
              small businesses market themselves like the household names they deserve to be.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#work" className="icg-btn icg-btn--dark">
                See our work <ArrowUpRight size={16} />
              </a>
              <a href="#services" className="icg-btn icg-btn--ghost">
                What we do
              </a>
            </div>
          </div>

          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <div className="w-full">
              <div className="icg-divider mb-6" />
              <div className="grid grid-cols-2 gap-x-6 gap-y-8">
                {stats.map((s) => (
                  <div key={s.label}>
                    <div className="font-display text-4xl md:text-5xl font-semibold tracking-tight">
                      {s.value}
                    </div>
                    <div className="mt-1 text-sm text-[color:var(--icg-muted)]">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-24 flex items-center gap-3 text-[color:var(--icg-muted)] icg-fade-up delay-3">
          <ArrowDown size={16} />
          <span className="text-sm">Scroll to explore</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
